import type { HTMLAttributes } from 'react'

import styles from './Badge.module.css'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone: 'green' | 'red' | 'orange' | 'gray' | 'blue'
  pill?: boolean
}

export function Badge({ tone, pill = false, className = '', ...props }: BadgeProps) {
  return <span className={`${styles.badge} ${styles[tone]} ${pill ? styles.pill : ''} ${className}`} {...props} />
}
